import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import classNames from 'classnames';
import Select from '../../../../../../../Inputs/Select';
import styles from '../index.module.scss';
import useIntakeData from '../../../../../../../../services/intakeDataService';
import { isEmpty } from 'lodash';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import { SELECT_NONE_OPTION } from '../../../../../../../../utils/noneOptionUtil';

export default function LocationField() {
  const { control } = useFormContext();
  const { data } = useIntakeData();

  if (isEmpty(data?.locations)) {
    return null;
  }

  const locationOptions = [SELECT_NONE_OPTION, ...(data?.locations ?? []).map((location) => ({
    label: location,
    value: location,
  }))]

  return (
    <FormControl
      className={classNames(
        styles.inputWrapper,
        styles.selectWrapper,
        styles.largeInputWrapper
      )}>
      <Controller
        defaultValue={SELECT_NONE_OPTION.value}
        render={({ field }) => (
          <Select
            options={locationOptions}
            label="Care location"
            {...field}
            IconComponent={ExpandMoreIcon}
            classes={{
              select: styles.inputField,
              icon: styles.selectIcon,
            }}
            className={styles.selectRoot}
            disableUnderline
            displayEmpty={true}
            renderValue={(value) => (
              <div
                className={classNames(styles.selectValue, {
                  [styles.placeholder]: value === SELECT_NONE_OPTION.value,
                })}>
                {locationOptions.find((option) => option.value === value)?.label}
              </div>
            )}
          />
        )}
        name="careLocation"
        control={control}
      />
    </FormControl>
  );
}
